import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from '../../axiosConfig';
import "../../styles/EditTrainingModal.css";

const EditTrainingModal = ({ isOpen, onClose, schoolId, trainingId, refreshCalendar }) => {
    const { t } = useTranslation('trainings');
    const [trainers, setTrainers] = useState([]);
    const [halls, setHalls] = useState([]);
    const [services, setServices] = useState([]);

    // Initialize each state with trainingToEdit values if available, otherwise empty string.
    const [selectedTrainer, setSelectedTrainer] = useState("");
    const [selectedHall, setSelectedHall] = useState("");
    const [selectedService, setSelectedService] = useState("");

    const token = localStorage.getItem("jwt");

    useEffect(() => {
        if (isOpen && schoolId) {
            // Fetch trainers for the school
            axios.get(`/api/v1/trainer/find-all/${schoolId}`, {
                headers: { Authorization: `Bearer ${token}` }
            })
                .then(res => setTrainers(res.data || []))
                .catch(err => console.error("Error fetching trainers", err));

            // Fetch halls for the school
            axios.get(`/api/v1/school/${schoolId}/halls`, {
                headers: { Authorization: `Bearer ${token}` }
            })
                .then(res => setHalls(res.data || []))
                .catch(err => console.error("Error fetching halls", err));

            // Fetch offered services for the school
            axios.get(`/api/v1/services/school/${schoolId}`, {
                headers: { Authorization: `Bearer ${token}` }
            })
                .then(res => setServices(res.data || []))
                .catch(err => console.error("Error fetching services", err));

            // Pre-fill selections (if trainingToEdit already has values)
            setSelectedTrainer("");
            setSelectedHall("");
            setSelectedService("");
        }
    }, [isOpen, schoolId, token]);

    const handleSave = async () => {
        const payload = {
            trainingId: trainingId,
            trainerId: selectedTrainer,
            hallId: selectedHall,
            serviceId: selectedService,
        };
        try {
            await axios.patch("/api/v1/training/edit", payload, {
                headers: { Authorization: `Bearer ${token}` }
            });
            alert(t('editSuccess'));
            refreshCalendar();
            onClose();
        } catch (err) {
            console.error("Error editing training", err);
            alert(t('editError'));
        }
    };

    const handleOverlayClick = (e) => {
        if (e.target.classList.contains('etm-overlay')) {
            onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <div className="etm-overlay" onClick={handleOverlayClick}>
            <div className="etm-modal">
                {/* Header */}
                <div className="etm-header">
                    <h2 className="etm-title">{t('editTraining')}</h2>
                    <p className="etm-subtitle">{t('editTrainingSubtitle')}</p>
                    <button className="etm-close-btn" onClick={onClose}>✕</button>
                </div>

                {/* Content */}
                <div className="etm-content">
                    {/* Trainer Selection */}
                    <div className="etm-form-group">
                        <label htmlFor="trainer-select" className="etm-label">
                            {t('selectTrainer')}
                        </label>
                        <select
                            id="trainer-select"
                            value={selectedTrainer}
                            onChange={(e) => setSelectedTrainer(e.target.value)}
                            className="etm-select"
                        >
                            <option value="">-- {t('choose')} --</option>
                            {trainers.map(tr => (
                                <option key={tr.id} value={tr.id}>
                                    {tr.firstName} {tr.lastName}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Hall Selection */}
                    <div className="etm-form-group">
                        <label htmlFor="hall-select" className="etm-label">
                            {t('selectHallLabel')}
                        </label>
                        <select
                            id="hall-select"
                            value={selectedHall}
                            onChange={(e) => setSelectedHall(e.target.value)}
                            className="etm-select"
                        >
                            <option value="">-- {t('choose')} --</option>
                            {halls.map(hall => (
                                <option key={hall.id} value={hall.id}>
                                    {hall.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Service Selection */}
                    <div className="etm-form-group">
                        <label htmlFor="service-select" className="etm-label">
                            {t('selectServiceLabel')}
                        </label>
                        <select
                            id="service-select"
                            value={selectedService}
                            onChange={(e) => setSelectedService(e.target.value)}
                            className="etm-select"
                        >
                            <option value="">-- {t('choose')} --</option>
                            {services.map(service => (
                                <option key={service.id} value={service.id}>
                                    {service.serviceName}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Footer */}
                <div className="etm-footer">
                    <button className="etm-cancel-btn" onClick={onClose}>
                        {t('cancel')}
                    </button>
                    <button
                        className="etm-save-btn"
                        onClick={handleSave}
                    >
                        {t('save')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EditTrainingModal;